/**
 * This function is always used in conjunction with `timePeriods` inorder to associate an object-key value to a time period.
 *
 * This function is an artifact from the older Angular app; therefore, the abstraction this function provides may
 * not be desirable moving forward.
 *
 * @param timePeriod {object}: A time period object from `timePeriods.js`.
 * @param attr {string}: The property/attribute name we want for the returned object.
 *
 * @return {object|null}: An object with the given property and value equal to the provided parameters.
 *
 * @example
 *  import getDateQry from "../../helpers/dateHelpers";
 *  import {DEFAULT_SELECTED_TIME_PERIOD} from "../../helpers/timePeriods";
 *
 *  getDateQry(DEFAULT_SELECTED_TIME_PERIOD, 'foo');
 */
const getDateQry = (timePeriod, attr) => {
    let query = {};

    if (!timePeriod.value) {
        return null;
    } else if (timePeriod.start) {
        query[attr] = [timePeriod.value, timePeriod.start, timePeriod.end].join(';');
        return query
    } else {
        query[attr] = timePeriod.value;
        return query;
    }
};

export default getDateQry;
